export default "__VITE_ASSET__BFeMS7Z2__"